<template>
    <section class="about-section">
        <div class="section-layout">
            <div class="media-block">
                <template v-if="aboutList.banner">
                    <img
                        v-if="isImage(aboutList.banner)"
                        :src="base_url + aboutList.banner"
                        alt="About banner"
                    />

                    <video
                        v-else-if="isVideo(aboutList.banner)"
                        :src="base_url + aboutList.banner"
                        controls
                    ></video>

                    <div v-else class="empty-state">Unsupported media format</div>
                </template>

                <div v-else class="empty-state">No media available</div>
            </div>

            <div class="story-block">
                <h2>Our Story</h2>
                <div class="story-copy" v-html="aboutList.our_story"></div>

                <button type="button" class="cta-button" @click="joinNow()">
                    <span>Join Us</span>
                    <MoveRight />
                </button>
            </div>
        </div>
    </section>
</template>

<script setup>
import { MoveRight } from "lucide-vue-next";
import { ref, onMounted } from "vue";
import axios from 'axios';
import router from "@/router";

const aboutList = ref({});
let base_url = process.env.VUE_APP_BASE_LIVE_URL;

onMounted(async () => {
  await listRecords();
});

const joinNow = async () => {
    router.push(`/register`);
};

const listRecords = async () => {
  try {
    const response = await axios.get('/about_list.php');
    aboutList.value = response.data.status ? response.data.data[0] : {};
  } catch (error) {
    console.error(error.message);
  }
};

const isImage = (file) => /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(file);
const isVideo = (file) => /\.(mp4|mov|webm|avi|mkv)$/i.test(file);
</script>

<style scoped lang="scss">
.about-section {
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
}

.section-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 32px;
    align-items: center;
}

.media-block img,
.media-block video {
    width: 100%;
    aspect-ratio: 16 / 10;
    object-fit: cover;
    border-radius: 24px;
    display: block;
    box-shadow: 0 18px 40px rgba(15, 23, 42, 0.1);
}

.empty-state {
    min-height: 360px;
    border-radius: 24px;
    border: 1px dashed #cbd5e1;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.story-block {
    padding: 8px 0;
}

.section-kicker {
    margin: 0 0 10px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.story-block h2 {
    margin: 0;
    font-size: clamp(28px, 3vw, 44px);
    line-height: 1.1;
    font-weight: 700;
    color: #0f172a;
}

.story-copy {
    margin-top: 16px;
    color: #334155;
    font-size: 16px;
    line-height: 1.85;
}

.cta-button {
    margin-top: 24px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    border: none;
    border-radius: 999px;
    padding: 14px 22px;
    background: #ed4e24;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    box-shadow: 0 12px 28px rgba(237, 78, 36, 0.24);
    cursor: pointer;
}

@media (max-width: 992px) {
    .section-layout {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .media-block img,
    .media-block video,
    .empty-state {
        aspect-ratio: auto;
        min-height: 260px;
    }
}
</style>
